import { CheckCircle } from '@firmable/icons';
import { Glass } from './Glass';
import { Hooks } from '@firmable/utilities';
import { useMemo } from 'react';

export type WelcomeMessageVariant = 'signup' | 'signin';

export interface WelcomeMessageProps {
  variant: WelcomeMessageVariant;
}

const baseContent = [
  'Smart platform built from the ground up',
  'AI agents prompt sales plays based on buying signals',
  'Helps your team prioritise high-intent prospects',
];

function getContent(variant: WelcomeMessageVariant, hideFreeTrialInfo: boolean): string[] {
  if (variant === 'signin') {
    return [...baseContent, 'Have an account? Log in now'];
  }
  if (hideFreeTrialInfo) {
    return baseContent;
  }
  return [...baseContent, 'Get started today with a free 14 day trial'];
}

export const WelcomeMessage = ({ variant }: WelcomeMessageProps) => {
  const { value: isFBLActive } = Hooks.useFBLActivate();
  const hideFreeTrialInfo = isFBLActive === 'true';

  const content = useMemo(() => getContent(variant, hideFreeTrialInfo), [variant, hideFreeTrialInfo]);

  return (
    <div className={'flex flex-col gap-10 w-full'}>
      <p className="text-white text-[64px] leading-[66px] font-medium tracking-[-1.28px]">
        Smarter data.
        <br />
        Sharper timing.
      </p>
      <Glass className="flex flex-col gap-3 p-6 w-[596px]">
        {content.map((text, index) => (
          <div key={index} className="flex flex-row gap-2 items-start">
            <CheckCircle className="shrink-0 mt-0.5 text-neutral-50" />
            <p className={'text-neutral-50 text-base leading-6'}>{text}</p>
          </div>
        ))}
      </Glass>
    </div>
  );
};
